import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

/** @jsx jsx */
import { forwardRef } from 'react';
import { jsx } from '@emotion/core';
import HeadingItem from '../item/heading-item';
import { sectionCSS } from './styles';
var Section = /*#__PURE__*/forwardRef( // Type needed on props to extract types with extract react types.
function (_ref, ref) {
  var children = _ref.children,
      overrides = _ref.overrides,
      title = _ref.title,
      testId = _ref.testId,
      rest = _objectWithoutProperties(_ref, ["children", "overrides", "title", "testId"]);

  return title !== undefined ? jsx(SectionBase, _extends({}, rest, {
    testId: testId,
    ref: ref,
    "aria-label": title
  }), jsx(HeadingItem, {
    cssFn: overrides && overrides.HeadingItem && overrides.HeadingItem.cssFn,
    testId: testId && "".concat(testId, "--heading"),
    "aria-hidden": true
  }, title), children) : jsx(SectionBase, _extends({}, rest, {
    ref: ref
  }), children);
});
export var SectionBase = /*#__PURE__*/forwardRef( // Type needed on props to extract types with extract react types.
function (_ref2, ref) {
  var isScrollable = _ref2.isScrollable,
      hasSeparator = _ref2.hasSeparator,
      testId = _ref2.testId,
      rest = _objectWithoutProperties(_ref2, ["isScrollable", "hasSeparator", "testId"]);

  return jsx("div", _extends({
    // NOTE: Firefox allows elements that have "overflow: auto" to gain focus (as if it had tab-index="0")
    // We have made a deliberate choice to leave this behaviour as is.
    css: sectionCSS(isScrollable, hasSeparator),
    "data-testid": testId,
    role: "group" // this is being used to target CSS selectors
    // where emotion's API was falling a little short.
    ,
    "data-section": true
  }, rest, {
    ref: ref
  }));
});
export default Section;